module.exports = __webpack_public_path__ + "img/crc-01.b085e380.jpg";